import * as FullStory from '@fullstory/browser';
import Vue from 'vue';
import store from 'client/signup/store/signupStore';

export default {
  initialize() {
    FullStory.init({
      orgId: 'o-1E90H9-na1',
    });
    Vue.prototype.$FullStory = FullStory;

    FullStory.setUserVars({
      referrerUrl: store.state.growthData.onboardingState.signupReferralUrl,
    });
  },

  setJumpcloudInternal(email) {
    const isJumpcloudInternal = Boolean(email.toLowerCase().indexOf('@jumpcloud.com') >= 0);

    FullStory.setUserVars({
      isJumpcloudInternal,
    });
  },
};
